function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBriefCase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "icon-briefcase"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.66667 5.83333V4.16667C6.66667 3.72464 6.84226 3.30072 7.15482 2.98816C7.46738 2.67559 7.89131 2.5 8.33333 2.5H11.6667C12.1087 2.5 12.5326 2.67559 12.8452 2.98816C13.1577 3.30072 13.3333 3.72464 13.3333 4.16667V5.83333M10 10V10.0083M2.5 10.8333C4.82632 12.0056 7.39502 12.6162 10 12.6162C12.605 12.6162 15.1737 12.0056 17.5 10.8333M2.5 7.5C2.5 7.05797 2.67559 6.63405 2.98816 6.32149C3.30072 6.00893 3.72464 5.83333 4.16667 5.83333H15.8333C16.2754 5.83333 16.6993 6.00893 17.0118 6.32149C17.3244 6.63405 17.5 7.05797 17.5 7.5V15C17.5 15.442 17.3244 15.866 17.0118 16.1785C16.6993 16.4911 16.2754 16.6667 15.8333 16.6667H4.16667C3.72464 16.6667 3.30072 16.4911 2.98816 16.1785C2.67559 15.866 2.5 15.442 2.5 15V7.5Z",
    stroke: "#667085",
    style: {
      stroke: "#667085",
      stroke: "color(display-p3 0.4009 0.4408 0.5207)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefCase);
export default __webpack_public_path__ + "static/media/BriefCase.237b11a1274b0210430a6ff2e1a2a024.svg";
export { ForwardRef as ReactComponent };